/*
  Hand-written tokens. Not in the Figma exports in tokens/collections, so the build can't generate them.
  TODO: where the F does this come from? Find the Figma source, export it, and delete this file.
  Imported last in variable.css, so it wins over generated values.
*/

:root {
  --primitives-gradient-yellow: linear-gradient(180deg, #EBFA63 25%, #DAF02B 38.64%);
  --primitives-bg-gradient: linear-gradient(179deg, rgba(0, 0, 0, 0.25) 45.72%, rgba(255, 0, 4, 0.25) 125.24%);

  /* Figma exports this as var(--primitives-colors-other-brand-secondary-0), but Primary buttons use the gradient on hover/pressed/focus. */
  --semantic-colors-other-brand-secondary-0: var(--primitives-gradient-yellow);

  /* Semantic Buttons (Text buttons) */
  --semantic-buttons-text-buttons-default-label: var(--semantic-colors-typography-heading);
  --semantic-buttons-text-buttons-default-bg: var(--semantic-colors-other-neutral-0-0);
  --semantic-buttons-text-buttons-default-border: var(--semantic-colors-other-neutral-0-0);
  --semantic-buttons-text-buttons-default-inner-shadow: var(--semantic-colors-other-innershadow-0);
  --semantic-buttons-text-buttons-default-icon: var(--semantic-colors-icons-default);
  --semantic-buttons-text-buttons-hover-label: var(--semantic-colors-typography-heading);
  --semantic-buttons-text-buttons-hover-bg: var(--semantic-colors-other-neutral-0-0);
  --semantic-buttons-text-buttons-hover-border: var(--semantic-colors-other-neutral-0-0);
  --semantic-buttons-text-buttons-hover-inner-shadow: var(--semantic-colors-other-innershadow-0);
  --semantic-buttons-text-buttons-hover-icon: var(--semantic-colors-icons-default);
  --semantic-buttons-text-buttons-pressed-label: var(--semantic-colors-typography-heading);
  --semantic-buttons-text-buttons-pressed-bg: var(--semantic-colors-other-neutral-0-0);
  --semantic-buttons-text-buttons-pressed-border: var(--semantic-colors-other-neutral-0-0);
  --semantic-buttons-text-buttons-pressed-inner-shadow: var(--semantic-colors-other-innershadow-0);
  --semantic-buttons-text-buttons-pressed-icon: var(--semantic-colors-icons-default);
  --semantic-buttons-text-buttons-disabled-label: var(--semantic-colors-typography-heading-disabled);
  --semantic-buttons-text-buttons-disabled-bg: var(--semantic-colors-other-neutral-0-0);
  --semantic-buttons-text-buttons-disabled-border: var(--semantic-colors-other-neutral-0-0);
  --semantic-buttons-text-buttons-disabled-inner-shadow: var(--semantic-colors-other-innershadow-0);
  --semantic-buttons-text-buttons-disabled-icon: var(--semantic-colors-icons-disabled);
  --semantic-buttons-text-buttons-focus-label: var(--semantic-colors-typography-heading);
  --semantic-buttons-text-buttons-focus-bg: var(--semantic-colors-other-neutral-0-0);
  --semantic-buttons-text-buttons-focus-border: var(--semantic-colors-other-border);
  --semantic-buttons-text-buttons-focus-inner-shadow: var(--semantic-colors-other-innershadow-0);
  --semantic-buttons-text-buttons-focus-icon: var(--semantic-colors-icons-default);
}
